
import {BaseComponent, IBaseComponentProps} from "../BaseComponent/BaseComponent"

export abstract class BaseView<TUrlState, TState = any> extends BaseComponent<IBaseComponentProps, TState>
{
    constructor(props: IBaseComponentProps)
    {
        super(props);
		window.onhashchange = this._onHashChange.bind(this);
    }

    public abstract setHashState(state);
	public abstract getHashState();
	private _ignoreNavigate: boolean = false;

	public override componentDidMount()
    {
		super.componentDidMount();
		this.setHashState(this._getStateFromHash());
	}

	private _onHashChange()
	{
		if (!this._ignoreNavigate)
		{
			this.setHashState(this._getStateFromHash());
		}

		this._ignoreNavigate = false;
	}

	protected makeHistory(title)
	{
		document.title = title;
		let newHash = this._getStateStringFromObject(this.getHashState());
		let oldHash = window.location.hash.replace("#", "");
		if (newHash !== oldHash)
		{
			window.location.hash = newHash;
			this._ignoreNavigate = true;
		}
		else
		{
			this._ignoreNavigate = false;
		}
	}

	protected replaceHistory(state)
	{
		history.replaceState(state, null, "#" + this._getStateStringFromObject(state));
	}

	protected _getStateFromHash(): TUrlState
	{
		var state = {} as TUrlState;
		var hash = window.location.hash;
		hash = hash.replace("#", "");
		var parts = hash.split("&");
		for(var i=0; i < parts.length; i++)
		{
			var subparts = parts[i].split("=");
			state[subparts[0]] = decodeURIComponent(subparts[1]);		
		}
		return state;
	}

	protected _getStateStringFromObject(data)
	{
	   var stateString= "";
	   var isFirst = true;
		for(var member in data)
        {
            if (data[member] == null)
            {
                continue;
            }

			if(!isFirst)
			{
				stateString += "&"
			}
			isFirst = false;
			stateString += member + "=" + encodeURIComponent(data[member]);

		}
		return stateString;
	}

	public hasHistory(): boolean
	{
		return window.location.hash.length > 1;
	}
}
